import React from "react";
import { Button, CircularProgress } from "@sscs/ui";
import styles from "./registerSuccess.module.scss";
import useRegisterMemberResendEmail from "./useResendRegisterMemberEmail";

type RegisterSuccessProps = {
  memberEmail: string;
};

const RegisterSuccess = ({
  memberEmail,
}: RegisterSuccessProps): React.JSX.Element => {
  const { handleResend, isResending } = useRegisterMemberResendEmail();

  return (
    <div className={styles.resend}>
      <span>Didn&apos;t receive a verification link?</span>
      <Button
        variant="text"
        isInline
        disabled={isResending}
        onClick={() => handleResend(memberEmail)}
      >
        Resend {isResending ? <CircularProgress /> : ""}
      </Button>
    </div>
  );
};

export default RegisterSuccess;
